import { FC, ReactNode } from "react";

export const TimerTextWrapper: FC<{ children: ReactNode }> = ({ children }) => {
  return (
    <div className="relative">
      {/* Invisible placeholder to avoid layout shift */}
      <span className="invisible block">00:00:00</span>
      <span className="absolute left-0 top-0">{children}</span>
    </div>
  );
};
